module.exports = __webpack_public_path__ + "static/media/ts.95d129e8.png";